/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Unserved_HintInputs */



/**
* | output |
* | --- |
* | "Live spaces on this provider are cut off until a package for it is pinned here." |
*
* @param {Partner_Connectors_Unserved_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_unserved_hint = /** @type {((inputs?: Partner_Connectors_Unserved_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Unserved_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktive Spaces dieses Anbieters sind abgeschnitten, bis hier ein Paket für ihn festgelegt wird.")
	return /** @type {LocalizedString} */ ("Live spaces on this provider are cut off until a package for it is pinned here.")
});